import React, { useState } from 'react';
import ReusableDiv from "src/helper/ReusableDiv";
import Helper from "src/helper/Helper";
import { useUserStore } from "src/hooks/admin/user";
import Constants from "src/helper/Constants";
import System from "src/helper/system";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { __remove, __set } from "src/store/axios_indicator";
import useReduxState from "src/hooks/useReduxState";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import ShowAlert from 'src/component/Global/ShowAlert';

const AddUser = (props) => {
  const { SetStatus } = props;
  const [{ }, { }, { add_user, check_user_email }] = useUserStore();

  const [__check] = useAxiosIndicatorCheck();
  const [detailValidation, setDetailValidation] = useState({});
  const [, setRefreshGrid] = useReduxState(false, "setRefreshGrid");
  const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
  const [emailStatus, setEmailStatus] = useState(false)

  const modal = {
    firstName: "",
    lastName: "",
    emailAddress: "",
    mobileNumber: "",
    telephoneNumber: "",
    userType: "External",
    registeredSpeedBoat: System.avUserInfoData.speedBoatAbbr,
    companyName: "",
  };
  const [userDetail, setUserDetail] = useState(modal);
  const { userType: { INTERNAL, EXTERNAL } } = Constants
  const { translation:t } = System;
  const firstNamePattern = System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) ? Constants.apacFirstNamePattern : Constants.japanFirstNamePattern
  const companyNamePattern = System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) ? Constants.apacCompanyNamePattern : Constants.japanCompanyNamePattern

  const onHide = () => {
    SetStatus(false);
  };

  const onValueChange = (field, value) => {
    if (detailValidation && Object.keys(detailValidation).length > 0) {
      delete detailValidation[field];
    }
    setUserDetail({ ...userDetail, [field]: value });

    if (userDetail.userType === INTERNAL && field === 'emailAddress' && emailStatus) {
      setUserDetail({ ...modal, emailAddress: value, userType: INTERNAL });
    }

    if (field === "userType") {
      setUserDetail({ ...modal, userType: value });
      setDetailValidation({});
    }
  };

  const onExistingEmailCheck = async () => {
    const isValid = validateEmail()

    if (isValid) {
      __set("CHECK_USER_EMAIL");
      const res = await check_user_email(userDetail.emailAddress)
      if (res && res?.isSuccessFull) {
        setEmailStatus(true)
        setUserDetail({ ...res?.data, userType: res?.data?.userType === 0 ? INTERNAL : EXTERNAL, registeredSpeedBoat: System.avUserInfoData.speedBoatAbbr })
      } else if (res && res.Message) {
        const validationModal = {}
        validationModal.emailAddress = res.Message;
        setDetailValidation(validationModal);
      } else {
        system_alert_indicator({
          name: "addUserError",
          message: t('ohSnapTheUserCouldNotBeAdded'),
          type: "danger",
          isDisplay: false,
          isDisplayIcon: true,
          addUsercontainer: true
        });
      }
      __remove("CHECK_USER_EMAIL");
    }
  };

  const onSaveUser = async () => {
    __set("ADD_USER_API_CALL");

    const isValid = userDetail?.userType === "External" ? onValidateData() : validateEmail()

    if (isValid) {
      const payload = {
        ...userDetail,
        companyName: userDetail?.companyName?.trim(),
        firstName: userDetail?.firstName?.trim(),
        lastName: userDetail?.lastName?.trim(),
        mobileNumber: userDetail?.mobileNumber?.trim(),
        telephoneNumber: userDetail?.telephoneNumber?.trim(),
      }
      Object.entries(userDetail).every(([field, value]) => { })
      const res = await add_user(payload);
      if (res && res.isSuccessFull) {
        const message = userDetail?.userType === "External" ? (t('youHaveSuccessfullyAdded') +
          res.username +
          t('emailHasBeenSentForConfirmation')) : (t('youHaveSuccessfullyAdded') +
            res.username + t('toTheSystem'))
        setTimeout(() => {
          system_alert_indicator({
            name: "adminconsole",
            message: message,
            type: "success",
            isDisplay: true,
          });
          setRefreshGrid(true);
        }, 500);

        onHide();
      } else if (res && res.Message) {
        const validationModal = {}
        if (['422', '402', '404'].includes(res?.ErrorCode)) {
          validationModal.emailAddress = res.Message;
          setDetailValidation(validationModal);
        } else {
          system_alert_indicator({
            name: "addUserError",
            message: t('ohSnapTheUserCouldNotBeAdded'),
            type: "danger",
            isDisplay: false,
            isDisplayIcon: true,
            addUsercontainer: true
          });
        }
      } else {
        system_alert_indicator({
          name: "addUserError",
          message: t('ohSnapTheUserCouldNotBeAdded'),
          type: "danger",
          isDisplay: false,
          isDisplayIcon: true,
          addUsercontainer: true
        });
      }
    }

    __remove("ADD_USER_API_CALL");
  };

  const onValidateData = () => {
    const validationModal = {};
    if (!Helper.valueIsNotNull(userDetail.firstName)) {
      validationModal.firstName = t('enterFirstName');
    }

    if (!Helper.valueIsNotNull(userDetail.lastName)) {
      validationModal.lastName = t('enterLastName');
    }

    if (!Helper.valueIsNotNull(userDetail.emailAddress)) {
      validationModal.emailAddress = t('enterEmailAddress')
    } else if (System.validateDomain(userDetail.emailAddress)) {
      validationModal.emailAddress = t('pleaseSelectTheInternalUserOption');
    }

    if (!Helper.valueIsNotNull(userDetail.mobileNumber)) {
      validationModal.mobileNumber = t('enterMobileNumber')
    }

    if (userDetail.userType === EXTERNAL && !Helper.valueIsNotNull(userDetail.companyName)) {
      validationModal.mobileNumber = t('enterCompanyName')
    }

    setDetailValidation(validationModal);
    return Object.keys(validationModal).length <= 0;
  };

  const validateEmail = () => {
    const validationModal = {};
    if (!Helper.valueIsNotNull(userDetail.emailAddress)) {
      validationModal.emailAddress = t('enterEmailAddress');
    } else if (!System.validateDomain(userDetail.emailAddress)) {
      validationModal.emailAddress = t('pleaseSelectExternalOption');
    }

    setDetailValidation(validationModal);
    return Object.keys(validationModal).length <= 0;
  }

  const enableField = Helper.valueIsNotNull(userDetail.firstName) && Helper.valueIsNotNull(userDetail.lastName) &&
    Helper.valueIsNotNull(userDetail.emailAddress) && Helper.validateRegex(userDetail.emailAddress, Constants.registerEmailPattern) &&
    (Helper.valueIsNotNull(userDetail.companyName) || userDetail.userType === INTERNAL) && Object.keys(detailValidation).length === 0


  const UserFields = () => {
    const valid = userDetail?.userType === "External"
    return (
      <>
        <div className=" bs5 row">
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="firstName" className={`d-block${valid ? '' : ' text-black-sand' }`}>
                {t('firstName')}*
              </label>
              <input
                  maxLength={35}
                type="text"
                className={`form-control form-control-sm ${valid && detailValidation && detailValidation.firstName
                  ? " error"
                  : ""
                  }`}
                id="firstName"
                placeholder={t('firstName')}
                name="firstName"
                value={userDetail.firstName}
                onChange={({ target: { value } }) =>
                  onValueChange("firstName", value)
                }
                disabled={!valid}
                  onBlur={() => {
                    if (userDetail.firstName) {
                      if (userDetail.firstName?.length < 2) {
                        setDetailValidation({ ...detailValidation, firstName: t('firstNameMustNotBeLessThan2Char') });
                        return;
                      }
                      if (!firstNamePattern.test(userDetail.firstName)) {
                        setDetailValidation({ ...detailValidation, firstName: t('firstNameEnglishValidation') });
                        return;
                      }
                    }
                  }}
              />
              {valid && detailValidation.firstName && (
                <p className="error"> {detailValidation.firstName}</p>
              )}
            </div>
          </div>

          <div className="col-6">
            <div className="form-group">
              <label htmlFor="mobileNumber" className={`d-block${valid ? '' : ' text-black-sand' }`}>
                {t('mobileNumber')}*
              </label>
              <input
                  maxLength={25}
                type="text"
                className={`form-control form-control-sm ${valid && detailValidation && detailValidation.mobileNumber
                  ? " error"
                  : ""
                  }`}
                id="mobileNumber"
                placeholder={t('mobileNumber')}
                name="mobileNumber"
                value={userDetail.mobileNumber}
                onChange={({ target: { value } }) =>
                  onValueChange("mobileNumber", value)
                }
                disabled={!valid}
                  onBlur={() => {
                    if (userDetail.mobileNumber) {
                      if (!Constants.phoneNumberPattern.test(userDetail.mobileNumber)) {
                        setDetailValidation({ ...detailValidation, mobileNumber: t('phoneNumberValidation') });
                      }
                    }
                  }}
              />
              {valid && detailValidation.mobileNumber && (
                <p className="error"> {detailValidation.mobileNumber}</p>
              )}
            </div>
          </div>
        </div>
        <div className=" bs5 row">
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="lastName" className={`d-block${valid ? '' : ' text-black-sand' }`}>
                {t('lastName')}*
              </label>
              <input
                type="text"
                maxLength={35}
                className={`form-control form-control-sm ${valid && detailValidation && detailValidation.lastName
                  ? " error"
                  : ""
                  }`}
                id="lastName"
                placeholder={t('lastName')}
                name="lastName"
                value={userDetail.lastName}
                onChange={({ target: { value } }) =>
                  onValueChange("lastName", value)
                }
                disabled={!valid}
                onBlur={() => {
                  if (userDetail.lastName) {
                    if (userDetail.lastName?.length < 2) {
                      setDetailValidation({ ...detailValidation, lastName: t('lastNameMustNotBeLessThan2Char') });
                      return;
                    }
                    if (!Constants.apacFirstNamePattern.test(userDetail.lastName)) {
                      setDetailValidation({ ...detailValidation, lastName: t('lastNameMustBeEnteredValidation') });
                      return;
                    }
                  }
                }}
              />
              {valid && detailValidation.lastName && (
                <p className="error"> {detailValidation.lastName}</p>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="telephoneNumber" className={`d-block${valid ? '' : ' text-black-sand' }`}>
                {t('telephoneNumber')}
              </label>
              <input
                  maxLength={25}
                type="text"
                className="form-control form-control-sm"
                id="telephoneNumber"
                placeholder={t('telephoneNumber')}
                name="telephoneNumber"
                value={userDetail.telephoneNumber}
                onChange={({ target: { value } }) =>
                  onValueChange("telephoneNumber", value)
                }
                disabled={!valid}
                  onBlur={() => {
                    if (userDetail.telephoneNumber) {
                      if (!Constants.phoneNumberPattern.test(userDetail.telephoneNumber)) {
                        setDetailValidation({ ...detailValidation, telephoneNumber: t('telephoneValidation') });
                        return;
                      }
                    }
                  }}
              />
              {detailValidation.telephoneNumber && (
                  <p className="error">
                    {" "}
                    {detailValidation.telephoneNumber}
                  </p>
              )}
            </div>
          </div>
        </div>
        <div className=" bs5 row">
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="email" className="d-block">
                {t('emailAddress')}*
              </label>
              <input
                  maxLength={70}
                type="text"
                className={`form-control form-control-sm ${detailValidation && detailValidation.emailAddress
                  ? " error" : ""}`}
                id="email"
                placeholder={t('emailAddress')}
                name="emailAddress"
                value={userDetail.emailAddress}
                onChange={({ target: { value } }) =>
                  onValueChange("emailAddress", value.trim())
                }
                onBlur={() => {
                  if (userDetail.emailAddress) {
                    if (!Constants.registerEmailPattern.test(userDetail.emailAddress)) {
                      setDetailValidation({ ...detailValidation, emailAddress: t('aValidEmailAddressIsRequired') });
                      return;
                    }
                    if (!valid) {
                      onExistingEmailCheck()
                    }
                  }
                }}
              />
              {detailValidation.emailAddress && (
                <p className="error">
                  {" "}
                  {detailValidation.emailAddress}
                </p>
              )}
            </div>
          </div>
          {userDetail.userType === EXTERNAL && <div className="col-6">
            <div className="form-group">
              <label htmlFor="companyName" className={`d-block${valid ? '' : ' text-black-sand' }`}>
                {t('companyName')}*
              </label>
              <input
                  maxLength={35}
                type="text"
                className={`form-control form-control-sm ${detailValidation && detailValidation.companyName
                  ? " error" : ""}`}
                id="companyName"
                placeholder={t('companyNamePH')}
                name="companyName"
                value={userDetail.companyName}
                onChange={({ target: { value } }) =>
                  onValueChange("companyName", value)
                }
                  onBlur={() => {
                    if (userDetail.companyName) {
                      if (!companyNamePattern.test(userDetail.companyName)) {
                        setDetailValidation({ ...detailValidation, companyName: t('companyNameEnglishValidation') });
                        return;
                      }
                    }
                  }}
              />
              {detailValidation.companyName && (
                <p className="error">
                  {" "}
                  {detailValidation.companyName}
                </p>
              )}
            </div>
          </div>}
          <div className="col-6">
            <div className="form-group m-t-25">
              {__check(["CHECK_USER_EMAIL"]).status &&
                <i className="fa fa-spinner fa-spin" />
              }
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="avnet-modal modal-730">
        <div className="avnet-modal-inner">
          <button
            type="button"
            className="close py-3"
            data-dismiss="modal"
            onClick={() => {
              onHide();
            }}
          >×
          </button>
          {ReusableDiv.PopupTitle(t('addUser'))}
          <div className="modal-body">
            <ShowAlert onlyShowMessage={['addUserError']} />

            <form>

              <p className="fw-bold">
                {t('pleaseSelectTheTypeOfUser')}
              </p>
              <div className="bs5 row">
                <div className="form-check-inline d-inline-flex align-items-center">
                  <div className="form-check form-check-inline d-inline-flex align-items-center pr-5 pb-3">
                    <input
                      type="radio"
                      className="form-check-input font-14"
                      id="externalUser"
                      // value={userDetail?.externalUser}
                      onChange={({ target: { checked } }) =>
                        onValueChange("userType", EXTERNAL)
                      }
                      name="users"
                      defaultChecked
                    />
                    <label
                      className="form-check-label mt-0 ms-2"
                      htmlFor="externalUser"
                    >
                      {t('externalUser')}
                    </label>
                  </div>
                  <div className="form-check form-check-inline d-inline-flex align-items-center pr-5 pb-3">
                    <input
                      type="radio"
                      className="form-check-input font-14"
                      id="internalUser"
                      // value={userDetail?.internalUser}
                      onChange={({ target: { checked } }) =>
                        onValueChange("userType", INTERNAL)
                      }
                      // value="Internal User"
                      name="users"
                    />
                    <label
                      className="form-check-label mt-0 ms-2"
                      htmlFor="internalUser"
                    >
                      {t('internalUser')}
                    </label>
                  </div>
                </div>
              </div>
              {UserFields()}
            </form>
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button
              type="button"
              className="bs5 btn btn-secondary minw140"
              onClick={() => {
                onHide();
              }}
            >
              {t('cancel')}
            </button>

            <button
              type="button"
              className="bs5 btn btn-primary minw140"
              disabled={__check(["ADD_USER_API_CALL"]).status || !enableField}
              onClick={() => {
                __check(["ADD_USER_API_CALL"]).status
                  ? e.preventDefault()
                  : onSaveUser();
              }}
            >
              {(__check("ADD_USER_API_CALL").status) ? (
                <i className="fa fa-spinner fa-spin " />
              ) : (
                t('addUser')
              )}{" "}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUser;
